import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-heading",
  templateUrl: "./med-icon-heading.component.html",
})
export class MedIconHeadingComponent extends SvgMixinComponent {}
